import { Typography } from '@material-ui/core'
import React from 'react'
import './Style.css'
import { useSelector, useDispatch } from 'react-redux'
import { setAccount } from 'redux/actions/'

export default function RadioCard() {
  const dispatch = useDispatch()
  const accountType = useSelector(state => state.signup.accountType)
  return (
    <section>
      <div>
        <input
          type="radio"
          id="control_01"
          className="radio-card"
          name="select"
          value="1"
          checked={accountType === 'agency'}
          onChange={() => dispatch(setAccount('agency'))}
        />
        <label className="radio-label" htmlFor="control_01">
          <Typography variant="h4">Ad Agency</Typography>
          <Typography variant="caption" className="radio-card-text">
            An Agency with multiple Ad accounts
          </Typography>
        </label>
      </div>
      <div>
        <input
          type="radio"
          id="control_02"
          className="radio-card"
          name="select"
          value="2"
          checked={accountType === 'advertiser'}
          onChange={() => dispatch(setAccount('advertiser'))}
        />
        <label className="radio-label" htmlFor="control_02">
          <Typography variant="h4">Advertiser</Typography>
          <Typography variant="caption" className="radio-card-text">
            A private company with single account
            <br />
            (I Own My Business)
          </Typography>
        </label>
      </div>
    </section>
  )
}
